// 用户中心
import { $patch, $get, $delete } from '@/utils/http'
import Service from './Service'

const BASEURL = "/ucenter/v2/notice"

// 获取项目下所有通知
Service.getNoticeList = async function (params) {
    let request = {}
    request['project_id'] = Service.getProjectSystemId();
    if (!request['project_id']) return;

    request['top'] = params.top;
    request['solved'] = params.solved;
    request['read'] = params.read;

    // 	第几页
    request['page_num'] = params.page_num;
    // 	一页几条数据
    request['page_sum'] = params.page_sum;

    let data = await $get(BASEURL + "/list", request, true);
    return Service.handleCommonError(data)
}


// 获取未读通知
Service.getNoticeUnReadList = async function () {
    let request = {}
    request['project_id'] = Service.getProjectSystemId();
    if (!request['project_id']) return;

    request['top'] = 0;
    request['solved'] = 0;
    request['read'] = 1;

    // 	第几页
    request['page_num'] = 1;
    // 	一页几条数据
    request['page_sum'] = 6;

    let data = await $get(BASEURL + "/list", request, true);
    return Service.handleCommonError(data)
}

// 获取单个通知
Service.getNoticeInfo = async function (params) {
    let request = {}
    
    // 通知OID
    request["oid"] = params.oid

    let data = await $get(BASEURL + "", request, true);
    return Service.handleCommonError(data)
}

// 删除通知
Service.delNotice = async function (params) {
    // let request = {}

    var formData = new FormData();
    formData.append("oidlist", JSON.stringify(params.oidlist));

    let data = await $delete(BASEURL + "", formData, true);
    return Service.handleCommonError(data)
}

// 通知已读
Service.readNotice = async function (params) {
    let request = {}

    // 通知OID
    request["oidlist"] = JSON.stringify(params.oidlist)

    let data = await $patch(BASEURL + "/read", request, true);
    return Service.handleCommonError(data)
}

// 通知已解决
Service.solveNotice = async function (params) {
    let request = {}

    // 通知OID
    request["oidlist"] = JSON.stringify(params.oidlist)
    
    let data = await $patch(BASEURL + "/solved", request, true);
    return Service.handleCommonError(data)
}

// 通知全部标记已读
Service.readallNotice = async function () {
    let request = {}

    request['project_id'] = Service.getProjectSystemId();
    if (!request['project_id']) return;

    let data = await $patch(BASEURL + "/readall", request);
    return Service.handleCommonError(data)
}

// 	获取项目下的日志
Service.getLog = async function (params) {
    let request = {}

    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;
	//开始时间
	request['start_time'] = params.start_time;
	
	//结束时间
	request['end_time'] = params.end_time;
	
    // 	第几页start_time
    request['page_num'] = params.page_num;
    // 	一页几条数据
    request['page_sum'] = params.page_sum;
    let data = await $get("/ucenter/v2/log/pid", request, true);
    return Service.handleCommonError(data)
}
